import {Routes} from "@buildwithflux/url";

import type {NavigationMenuGroup, NavigationMenuItem, NavigationUser} from "./types";

/**
 * Logo-dropdown items, mirroring the main app's ActionsMenu on non-editor
 * pages (minus internal-only and document-context items). Import requires the
 * app runtime for its submenu, so it links into the app home.
 */
export function getFluxMenuItems(isAuthenticated: boolean): NavigationMenuItem[] {
    const items: NavigationMenuItem[] = [];

    if (isAuthenticated) {
        items.push({
            id: "import",
            label: "Import",
            icon: "CloudUpload",
            href: "/",
            dividerAfter: true,
        });
    }

    items.push(
        {
            id: "new-project",
            label: "New Project",
            icon: "Add",
            href: `${Routes.CREATE_DOCUMENT}?origin=Menu`,
        },
        {
            id: "new-project-from-template",
            label: "New Project from Template",
            icon: "AddBox",
            href: `${Routes.CREATE_DOCUMENT_FROM_TEMPLATE}?origin=Menu`,
        },
    );

    return items;
}

export function getAccountMenuItems(
    user: NavigationUser,
    logOut: () => void,
): NavigationMenuItem[] {
    const profileUrl = user.handle ? `/${user.handle}` : "/";
    // Plan & Payments is a same-origin hard-link to the account's billing page,
    // which loads the same content as the in-app billing dialog. Falls back to
    // the profile root when the handle is unavailable.
    const billingUrl = user.handle ? `${profileUrl}/billing` : profileUrl;

    return [
        {
            id: "profile",
            label: "Profile",
            icon: "Avatar",
            href: profileUrl,
        },
        {
            id: "billing",
            label: "Plan & Payments",
            icon: "CreditCard",
            href: billingUrl,
            dividerAfter: true,
        },
        {
            id: "logout",
            label: "Log out",
            icon: "ExitToApp",
            onClick: logOut,
        },
    ];
}

export function getAccountMenuGroups(
    user: NavigationUser,
    logOut: () => void,
): NavigationMenuGroup[] {
    const profileUrl = user.handle ? `/${user.handle}` : "/";
    const billingUrl = user.handle ? `${profileUrl}/billing` : profileUrl;

    return [
        {
            id: "identity",
            items: [
                {
                    id: "profile",
                    label: "Profile",
                    icon: "Avatar",
                    href: profileUrl,
                },
                {
                    id: "billing",
                    label: "Plan & Payments",
                    icon: "CreditCard",
                    href: billingUrl,
                },
            ],
        },
        {
            id: "session",
            items: [
                {
                    id: "logout",
                    label: "Log out",
                    icon: "ExitToApp",
                    onClick: logOut,
                },
            ],
        },
    ];
}
